import SoftButton from "components/SoftButton";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useState, useEffect } from "react";
import SoftBox from "components/SoftBox";
import SoftEditor from "components/SoftEditor";
import { htmlHasContent } from "helpers/common";
import { updateConnectorVersion } from "api/ConnectorVersions";
import { CircularProgress } from "@mui/material";
import { toast } from "react-toastify";

export const ReleaseNotesDialog = ({ open, onClose, version, handleUpdateVersion, isReadOnlyAccess }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [releaseNotes, setReleaseNotes] = useState("");
  const [isSavingReleaseNotes, setIsSavingReleaseNotes] = useState(false);

  const handleEdit = () => {
    setIsEditing(true);
  };

  const handleOnMouseEnter = () => {
    document.body.style.overflow = "hidden";
  };

  const handleOnMouseLeave = () => {
    document.body.style.overflow = "visible";
  };

  const handleSaveReleaseNotes = async () => {
    if (isSavingReleaseNotes) return;

    try {
      setIsSavingReleaseNotes(true);
      const { id, updated_datetime, created_datetime, file_name, file_size, ...restVersion } =
        version;

      const input = {
        ...restVersion,
        release_notes: releaseNotes,
        filename: file_name,
        filesize: file_size,
      };

      const result = await updateConnectorVersion(input, id);
      
      if (result.success) {
        result.data.id = id;
        handleUpdateVersion(Object.assign(result.data, input));

        setIsEditing(false);

        if (!htmlHasContent(releaseNotes)) {
          setReleaseNotes("");
        }

        toast.success("Successfully updated release notes");
      } else toast.error(`Unable to replace connector version. ${result.message}`, { autoClose: false, closeButton: true });
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong, please try again");
    }

    setIsSavingReleaseNotes(false);
  };

  useEffect(() => {
    if (!version) return;

    if (version.release_notes && htmlHasContent(version.release_notes)) {
      setReleaseNotes(version.release_notes);
    }
  }, [version]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>Release Notes</DialogTitle>
      <DialogContent>
        {!isEditing && (
          <SoftBox
            sx={{
              textAlign: "center",
            }}
          >
            <SoftEditor
              className="documentation preview"
              theme="bubble"
              value={version.release_notes}
              readOnly
            />
          </SoftBox>
        )}
        {isEditing && (
          <SoftBox onMouseEnter={handleOnMouseEnter} onMouseLeave={handleOnMouseLeave}>
            <SoftEditor
              theme="snow"
              value={releaseNotes}
              onChange={(value) => setReleaseNotes(value)}
            />
          </SoftBox>
        )}
      </DialogContent>
      <DialogActions>
        <SoftButton onClick={onClose} color="primary" variant="outlined">
          Close
        </SoftButton>
        {!isReadOnlyAccess && (
          <SoftButton color="info" onClick={isEditing ? handleSaveReleaseNotes : handleEdit}>
            {isSavingReleaseNotes ? (
              <CircularProgress
                size={24}
                sx={{
                  color: "#fff",
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  marginTop: "-12px",
                  marginLeft: "-12px",
                  zIndex: 1,
                }}
              />
            ) : isEditing ? (
              "Save"
            ) : (
              "Edit"
            )}
          </SoftButton>
        )}
      </DialogActions>
    </Dialog>
  );
};
